// extracted by mini-css-extract-plugin
export default {"resetFilters":"ResetFiltersButton_resetFilters__5Xq+B"};